import { render, staticRenderFns } from "./scene1.vue?vue&type=template&id=497fb1a7&"
import script from "./scene1.vue?vue&type=script&lang=js&"
export * from "./scene1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports